import React from 'react'

import AttendanceBotAvatar from './AttendanceBotAvatar'

interface TypingIndicatorProps {
  theme: 'light' | 'dark'
}

const TypingIndicator: React.FC<TypingIndicatorProps> = () => {
  return (
    <div className='chatbot-message-row chatbot-message-row--bot'>
      <div className='chatbot-bot-avatar chatbot-bot-avatar--mascot' aria-hidden='true'>
        <AttendanceBotAvatar />
      </div>
      <div className='chatbot-typing-bubble'>
        <div className='d-flex gap-1 align-items-center'>
          <div
            className='rounded-circle'
            style={{
              width: '8px',
              height: '8px',
              background: 'var(--chatbot-brand)',
              animation: 'bounce 1.4s infinite ease-in-out both',
              animationDelay: '-0.32s',
            }}
          />
          <div
            className='rounded-circle'
            style={{
              width: '8px',
              height: '8px',
              background: 'var(--chatbot-brand)',
              animation: 'bounce 1.4s infinite ease-in-out both',
              animationDelay: '-0.16s',
            }}
          />
          <div
            className='rounded-circle'
            style={{
              width: '8px',
              height: '8px',
              background: 'var(--chatbot-brand)',
              animation: 'bounce 1.4s infinite ease-in-out both',
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default TypingIndicator
